// import { memo, useState, useEffect, useContext } from 'react';
// import {
//   Card, CardContent, Box, Typography,
//   IconButton, CircularProgress, Button,
// } from '@mui/material';
// import {
//   LocationOn, ArrowForward, Call,
// } from '@mui/icons-material';
// import { AuthContext } from './../../AuthContext/AuthContext';
// import { BASE_URL } from './../../Api/ApiUrls';
// import GuestLoginModal from '../../GuestLoginModal';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';

// // ─── Full Indian number format ────────────────────────────────────────────────
// const formatPrice = (price) => {
//   const num = Number(price);
//   if (!num || isNaN(num) || num <= 0) return '0';
//   return num.toLocaleString('en-IN');
// };

// const formatPropertyId = (id) =>
//   `PR${String(id || '').padStart(4, '0')}`;

// const truncateText = (text, maxLength = 16) => {
//   if (!text) return '-';
//   const clean = text.toString().replace(/\s+/g, ' ').trim();
//   return clean.length > maxLength ? clean.substring(0, maxLength) + '...' : clean;
// };

// const getAreaNumber = (property) => {
//   if (!property) return 0;
//   if (property.siteArea)     return parseFloat(property.siteArea)     || 0;
//   if (property.buildupArea)  return parseFloat(property.buildupArea)  || 0;
//   if (property.site_area)    return parseFloat(property.site_area)    || 0;
//   if (property.buildup_area) return parseFloat(property.buildup_area) || 0;
//   if (property.max_acres)    return parseFloat(property.max_acres)    || 0;
//   if (property.maxAcres)     return parseFloat(property.maxAcres)     || 0;
//   if (property.length && property.width) {
//     return parseFloat(property.length) * parseFloat(property.width) || 0;
//   }
//   return 0;
// };

// const getPricePerUnit = (property) => {
//   const rawPrice =
//     property?.price ??
//     property?.effectivePrice ??
//     property?.effective_price ??
//     property?.minBudget ??
//     property?.min_budget ??
//     property?.budget ??
//     property?.total_price;

//   const price = parseFloat(String(rawPrice ?? '').replace(/[^0-9.]/g, ''));
//   if (!price || price <= 0) return null;

//   const area = getAreaNumber(property);
//   if (!area || area <= 0) return null;

//   const u = String(property.units || '').toLowerCase();
//   let unit = 'sft';
//   if (['acre', 'acres'].includes(u))   unit = 'acre';
//   if (['gunta', 'guntas'].includes(u)) unit = 'gunta';

//   return { value: Math.round(price / area), unit };
// };

// function JvJdPropertyCardImpl({ property, selected, onClick, showAlert, activityType }) {
//   const { userId, isGuest } = useContext(AuthContext);
//   const navigate = useNavigate();

//   const [loading, setLoading] = useState(false);
//   const [showGuestModal, setShowGuestModal] = useState(false);
//   const [userPlan, setUserPlan] = useState(null);
//   const [userActivities, setUserActivities] = useState([]);

//   const [userType] = useState('Buyer');

//   // ── Property type / land check ────────────────────────────────────────────
//   const propertyType = property.propertyType || property.property_type || 'Land';
//   const isLand = String(propertyType).toLowerCase().includes('land');

//   // ── Field mapping (both camelCase & snake_case) ──────────────────────────
//   const minAcres = property.minAcres ?? property.min_acres ?? '-';
//   const maxAcres = property.maxAcres ?? property.max_acres ?? '-';
//   const facing   = property.facing || '-';
//   const ratio    = property.ratio  || '-';
//   const postedBy = property.postedBy || property.posted_by || 'Agent';
//   const roadwidth = property.roadwidth ?? property.road_width ?? '-';
//   const units = property.units || '-';
//   const locationText = property.location || property.city || 'Location';

//   // ── Price fallback chain ───────────────────────────────────────────────────
//   const priceValue =
//     property.price ??
//     property.effectivePrice ??
//     property.effective_price ??
//     property.minBudget ??
//     property.min_budget ??
//     property.budget ??
//     property.total_price ??
//     0;

//   // ── User plan ──────────────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchUserPlan = async () => {
//       if (!userId) { setUserPlan(null); return; }
//       try {
//         const r = await axios.get(`${BASE_URL}/Get-user-plan/${userId}/`);
//         const plans = r.data;
//         const active = Array.isArray(plans)
//           ? plans.find(p => p.user_type === userType)
//           : plans.user_type === userType ? plans : null;
//         setUserPlan(active);
//       } catch { setUserPlan(null); }
//     };
//     fetchUserPlan();
//   }, [userId, userType]);

//   // ── Activities ─────────────────────────────────────────────────────────────
//   useEffect(() => {
//     const load = async () => {
//       if (!userId) return;
//       try {
//         const r = await fetch(`${BASE_URL}/activities/`);
//         const all = await r.json();
//         setUserActivities(all.filter(a => String(a.user_id) === String(userId)));
//       } catch { setUserActivities([]); }
//     };
//     load();
//   }, [userId]);

//   // ── Helpers ────────────────────────────────────────────────────────────────
//   const checkPropertyLimit = (pid) => {
//     if (userPlan?.no_of_properties_unlimited) return true;
//     const already = userActivities.some(a => a.property_id === pid && a.activity_as === userType);
//     if (already) return true;
//     const uniq = new Set(userActivities.filter(a => a.activity_as === userType).map(a => a.property_id));
//     if (uniq.size >= (userPlan?.no_of_properties || 10)) return false;
//     return true;
//   };

//   const logActivity = async (type) => {
//     try {
//       const exists = userActivities.find(a => a.property_id === property.id && a.activity_as === userType);
//       if (exists) return true;
//       let owner = property.owner_id ?? property.user_id ?? null;
//       if (!owner) {
//         try {
//           const r = await fetch(`${BASE_URL}/property/${property.id}/`);
//           if (r.ok) {
//             const d = await r.json();
//             owner = d.user_id ?? d.owner ?? d.posted_by ?? null;
//           }
//         } catch {}
//       }
//       const res = await fetch(`${BASE_URL}/activities/`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           user_id: userId, property_id: property.id,
//           activity_type: type, property_by: owner, activity_as: userType,
//         }),
//       });
//       if (!res.ok) throw new Error('fail');
//       const newA = await res.json();
//       setUserActivities(prev => [...prev, newA]);
//       return true;
//     } catch { return false; }
//   };

//   const requireLogin = (e, cb) => {
//     e.stopPropagation();
//     if (isGuest) { setShowGuestModal(true); return; }
//     cb();
//   };

//   // ── Location ───────────────────────────────────────────────────────────────
//   const handleLocationClick = (e) => {
//     requireLogin(e, () => {
//       const hasCoords = property.lat && property.lng;
//       const dest = hasCoords
//         ? `${property.lat},${property.lng}`
//         : encodeURIComponent(property.location || '');
//       if (!dest) { showAlert?.('failure', 'Location not available'); return; }

//       const ua = navigator.userAgent || navigator.vendor || window.opera;
//       const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;

//       const buildURL = (lat, lng) => {
//         if (isIOS) {
//           return lat
//             ? `https://maps.apple.com/?saddr=${lat},${lng}&daddr=${dest}&dirflg=d`
//             : `https://maps.apple.com/?q=${dest}`;
//         }
//         return lat
//           ? `https://www.google.com/maps/dir/?api=1&origin=${lat},${lng}&destination=${dest}&travelmode=driving`
//           : `https://www.google.com/maps/search/?api=1&query=${dest}`;
//       };
//       const open = (url) => { setLoading(false); window.open(url, '_blank', 'noopener,noreferrer'); };

//       if (navigator.geolocation && hasCoords) {
//         setLoading(true);
//         navigator.geolocation.getCurrentPosition(
//           (p) => open(buildURL(p.coords.latitude, p.coords.longitude)),
//           () => open(buildURL()),
//           { timeout: 8000, enableHighAccuracy: false }
//         );
//       } else {
//         open(buildURL());
//       }
//     });
//   };

//   // ── Handle call click ──────────────────────────────────────────────────────
//   const handleCallClick = (e) => {
//     e.stopPropagation();

//     const phoneNumber = property.mobileNo || property.mobile_no;

//     if (phoneNumber) {
//       const proceedAction = () => {
//         navigator.clipboard.writeText(phoneNumber)
//           .then(() => {
//             if (showAlert) {
//               showAlert('success', `Phone number copied: ${phoneNumber}`);
//             } else {
//               alert(`Phone number copied: ${phoneNumber}`);
//             }
//           })
//           .catch((error) => {
//             console.error('Failed to copy:', error);
//             if (showAlert) {
//               showAlert('failure', 'Failed to copy phone number');
//             }
//           });
//       };

//       if (isGuest) {
//         setShowGuestModal(true);
//       } else {
//         proceedAction();
//       }
//     } else {
//       const fetchAndCopyNumber = async () => {
//         try {
//           const ownerId = property.user_id || property.userId;
//           if (!ownerId) {
//             throw new Error('No user ID available');
//           }
//           const response = await axios.get(`${BASE_URL}/users/${ownerId}/`);
//           const user = response.data;

//           if (user && user.mobile_no) {
//             await navigator.clipboard.writeText(user.mobile_no);
//             if (showAlert) {
//               showAlert('success', `Phone number copied: ${user.mobile_no}`);
//             }
//           } else {
//             throw new Error('No phone number found for this user');
//           }
//         } catch (error) {
//           console.error('Error fetching phone number:', error);
//           if (showAlert) {
//             showAlert('failure', 'No contact information available');
//           } else {
//             alert('No contact information available');
//           }
//         }
//       };

//       if (isGuest) {
//         setShowGuestModal(true);
//       } else {
//         fetchAndCopyNumber();
//       }
//     }
//   };

// // ── Card click ─────────────────────────────────────────────────────────────
// const handleCardClick = async (e) => {
//   e.stopPropagation();

//   if (isGuest) {
//     setShowGuestModal(true);
//     return;
//   }

//   const already = userActivities.some(
//     a =>
//       a.property_id === property.id &&
//       a.activity_as === userType
//   );

//   if (!already) {
//     if (!checkPropertyLimit(property.id)) return;

//     try {
//       await logActivity('Description');
//     } catch (error) {
//       console.error('Error logging description view activity:', error);
//     }
//   }

//   localStorage.setItem('lastViewedPropertyId', property.id);

//   navigate(`/jv-jv-property-detail/${property.id}`);
// };

//   const pricePerUnit = getPricePerUnit(property);
//   const totalArea = getAreaNumber(property);

//   const locationParts = (property.location || '').split(',').map(s => s.trim()).filter(Boolean);
//   const localityLine = property.locality || property.area || locationParts[0] || 'Location';

//   const createdAt = property.createdAt || property.created_at;
//   const formattedDate = createdAt
//     ? new Date(createdAt).toLocaleDateString('en-IN', {
//         day: '2-digit', month: '2-digit', year: 'numeric',
//       })
//     : '-';

//   return (
//     <>
//       <Card
//         onClick={handleCardClick}
//         sx={{
//           width: '100%',
//           height: 125,                 // reduced from 150
//           maxWidth: 290,
//           cursor: 'pointer',
//           borderRadius: 2,
//           overflow: 'hidden',
//           transform: selected ? 'translateY(-2px)' : 'none',
//           transition: 'transform 200ms, border-color 200ms',
//           boxShadow: selected ? '0 4px 12px rgba(0,0,0,0.5)' : '0 2px 6px rgba(0,0,0,0.3)',
//           bgcolor: '#fff',
//           flexShrink: 0,
//         }}
//       >
//         <CardContent
//           sx={{
//             p: 0.75,                    // reduced from 0.7
//             display: 'flex', flexDirection: 'column',
//             justifyContent: 'space-between',
//             height: 125,               // match card height
//             boxSizing: 'border-box',
//             '&:last-child': { pb: 0.75 },
//           }}
//         >
//           {/* Row 1: Property ID | Date */}
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//             <Typography
//               fontWeight="bold"
//               noWrap
//               sx={{
//                 fontSize: '0.65rem', lineHeight: 1.1,
//                 overflow: 'hidden', textOverflow: 'ellipsis',
//                 flex: 1, minWidth: 0,
//               }}
//             >
//               Property ID: {formatPropertyId(property.id || property.property_id || property.req_id)}
//             </Typography>

//             <Typography
//               noWrap
//               sx={{
//                 flexShrink: 0,
//                 fontSize: '0.42rem',
//                 lineHeight: 1.1,
//                 px: 0.35, py: 0.1,
//                 whiteSpace: 'nowrap',
//               }}
//             >
//               <b>Date:</b> {formattedDate}
//             </Typography>
//           </Box>

//           {/* Row 2: Price / Per sft | Total Price */}
//           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//             <Box sx={{ flex: 1, minWidth: 0 }}>
//               <Typography sx={{ fontSize: '0.42rem', color: '#888', lineHeight: 1 }}>
//                 Price / Per {pricePerUnit?.unit || 'sft'}
//               </Typography>
//               <Typography fontWeight="bold" sx={{ fontSize: '0.6rem', color: '#c98a2c', lineHeight: 1.1 }}>
//                 ₹{pricePerUnit ? formatPrice(pricePerUnit.value) : 'NA'}
//               </Typography>
//             </Box>

//             <Box sx={{ width: '1px', height: 16, bgcolor: '#e0e0e0', mx: 0.35 }} />

//             <Box sx={{ flex: 1, minWidth: 0, textAlign: 'right' }}>
//               <Typography sx={{ fontSize: '0.42rem', color: '#888', lineHeight: 1 }}>
//                 Total Price
//               </Typography>
//               <Typography fontWeight="bold" sx={{ fontSize: '0.6rem', lineHeight: 1.1 }}>
//                 ₹{formatPrice(priceValue)}
//               </Typography>
//             </Box>
//           </Box>

//           {/* Row 3: Location + Call */}
//           <Box
//             // onClick={handleLocationClick}
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: 0.35,
//               cursor: 'pointer',
//               borderRadius: 1,
//               px: 0.25,
//               '&:hover': { backgroundColor: 'rgba(201,138,44,0.10)' },
//             }}
//           >
//             <LocationOn sx={{ fontSize: '0.7rem', color: '#c98a2c', flexShrink: 0 }} />

//             <Typography
//               noWrap
//               sx={{
//                 fontSize: '0.52rem',
//                 color: '#333',
//                 fontWeight: 500,
//                 lineHeight: 1.1,
//                 overflow: 'hidden',
//                 textOverflow: 'ellipsis',
//                 textDecoration: 'underline',
//                 textDecorationColor: 'rgba(201,138,44,0.4)',
//                 flex: 1,
//                 minWidth: 0,
//               }}
//             >
//               {localityLine}
//             </Typography>

//             <IconButton
//               size="small"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 handleCallClick(e);
//               }}
//               sx={{
//                 p: 0.15,
//                 flexShrink: 0,
//                 color: '#c98a2c',
//                 bgcolor: 'rgba(201,138,44,0.08)',
//                 '&:hover': {
//                   bgcolor: 'rgba(201,138,44,0.20)',
//                   transform: 'scale(1.08)',
//                 },
//                 transition: 'transform 0.15s, background-color 0.15s',
//               }}
//             >
//               <Call sx={{ fontSize: '0.7rem' }} />
//             </IconButton>
//           </Box>

//           {/* Row 4: Info grid (By / Min-Max-Facing / Ratio-Road) */}
//           <Box
//             sx={{
//               display: 'flex',
//               flexDirection: 'column',
//               border: '1px solid #e0e0e0',
//               borderRadius: '5px',
//               overflow: 'hidden',
//             }}
//           >
//             {/* By */}
//             <Box sx={{ display: 'flex', borderBottom: '1px solid #e0e0e0' }}>
//               <Typography
//                 noWrap
//                 sx={{
//                   flex: 1, minWidth: 0, fontSize: '0.42rem',
//                   lineHeight: 1.05, px: 0.35, py: 0.1,
//                   borderRight: '1px solid #e0e0e0',
//                 }}
//               >
//                 <b>By:</b> {postedBy}
//               </Typography>
//             </Box>

//             {/* Min/Max | Facing */}
//             <Box sx={{ display: 'flex', borderBottom: '1px solid #e0e0e0' }}>
//               <Typography
//                 noWrap
//                 sx={{
//                   flex: 1, minWidth: 0, fontSize: '0.42rem',
//                   lineHeight: 1.05, px: 0.35, py: 0.1,
//                   borderRight: '1px solid #e0e0e0',
//                 }}
//               >
//                 {isLand ? (
//                   <><b>Min/Max:</b> {minAcres}/{maxAcres}</>
//                 ) : (
//                   <><b>Area:</b> {totalArea > 0 ? totalArea : '-'}</>
//                 )}
//               </Typography>
//               <Typography
//                 noWrap
//                 sx={{ flex: 1, minWidth: 0, fontSize: '0.42rem', lineHeight: 1.05, px: 0.35, py: 0.1 }}
//               >
//                 <b>Facing:</b> {facing}
//               </Typography>
//             </Box>

//             {/* Ratio | Road */}
//             <Box sx={{ display: 'flex' }}>
//               <Typography
//                 noWrap
//                 sx={{
//                   flex: 1, minWidth: 0, fontSize: '0.42rem',
//                   lineHeight: 1.05, px: 0.35, py: 0.1,
//                   borderRight: '1px solid #e0e0e0',
//                 }}
//               >
//                 <b>Ratio:</b> {ratio}
//               </Typography>
//               <Typography
//                 noWrap
//                 sx={{ flex: 1, minWidth: 0, fontSize: '0.42rem', lineHeight: 1.05, px: 0.35, py: 0.1 }}
//               >
//                 <b>Road:</b> {roadwidth}{roadwidth !== '-' ? ' ft' : ''}
//               </Typography>
//             </Box>
//           </Box>

//           {/* Row 5: View Details */}
//           <Button
//             variant="contained"
//             size="small"
//             fullWidth
//             onClick={handleCardClick}
//             sx={{
//               py: 0.05,
//               fontSize: '0.7rem', fontWeight: 600,
//               bgcolor: '#c98a2c', color: '#000',
//               borderRadius: '2px',
//               '&:hover': { bgcolor: '#f5f5f5' },
//               textTransform: 'none',
//               minHeight: 16,
//               display: 'flex', justifyContent: 'space-between',
//               alignItems: 'center', px: 1.2,
//             }}
//           >
//             View Details
//             <ArrowForward sx={{ fontSize: '0.7rem' }} />
//           </Button>
//         </CardContent>
//       </Card>

//       <GuestLoginModal open={showGuestModal} onClose={() => setShowGuestModal(false)} />
//     </>
//   );
// }

// export default memo(JvJdPropertyCardImpl, (prevProps, nextProps) => {
//   return (
//     prevProps.property?.id === nextProps.property?.id &&
//     prevProps.selected === nextProps.selected
//   );
// });





//=======================================================
// below code with image displaying 


// import { memo, useState, useEffect, useContext } from 'react';
// import {
//   Card, CardMedia, CardContent, Box, Typography,
//   IconButton, CircularProgress, Button, Tooltip,
// } from '@mui/material';
// import {
//   LocationOn, ArrowForward, Call, ChevronLeft, ChevronRight,
// } from '@mui/icons-material';
// import { AuthContext } from './../../AuthContext/AuthContext';
// import { BASE_URL } from './../../Api/ApiUrls';
// import { getPropertyImages } from './api2.js';   // ✅ IMPORT ADDED
// import GuestLoginModal from '../../GuestLoginModal';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';

// // ─── Full Indian number format ────────────────────────────────────────────────
// const formatPrice = (price) => {
//   const num = Number(price);
//   if (!num || isNaN(num) || num <= 0) return '0';
//   return num.toLocaleString('en-IN');
// };

// const formatPropertyId = (id) =>
//   `PR${String(id || '').padStart(4, '0')}`;

// const getAreaNumber = (property) => {
//   if (!property) return 0;
//   if (property.siteArea)     return parseFloat(property.siteArea)     || 0;
//   if (property.buildupArea)  return parseFloat(property.buildupArea)  || 0;
//   if (property.site_area)    return parseFloat(property.site_area)    || 0;
//   if (property.buildup_area) return parseFloat(property.buildup_area) || 0;
//   if (property.max_acres)    return parseFloat(property.max_acres)    || 0;
//   if (property.maxAcres)     return parseFloat(property.maxAcres)     || 0;
//   if (property.length && property.width) {
//     return parseFloat(property.length) * parseFloat(property.width) || 0;
//   }
//   return 0;
// };

// const getPricePerUnit = (property) => {
//   const rawPrice =
//     property?.price ??
//     property?.effectivePrice ??
//     property?.effective_price ??
//     property?.minBudget ??
//     property?.min_budget ??
//     property?.budget ??
//     property?.total_price;

//   const price = parseFloat(String(rawPrice ?? '').replace(/[^0-9.]/g, ''));
//   if (!price || price <= 0) return null;

//   const area = getAreaNumber(property);
//   if (!area || area <= 0) return null;

//   const u = String(property.units || '').toLowerCase();
//   let unit = 'sft';
//   if (['acre', 'acres'].includes(u))   unit = 'acre';
//   if (['gunta', 'guntas'].includes(u)) unit = 'gunta';

//   return { value: Math.round(price / area), unit };
// };

// function JvJdPropertyCardImpl({ property, selected, onClick, showAlert, activityType }) {
//   const { userId, isGuest } = useContext(AuthContext);
//   const navigate = useNavigate();

//   const [loading, setLoading] = useState(false);
//   const [showGuestModal, setShowGuestModal] = useState(false);
//   const [userPlan, setUserPlan] = useState(null);
//   const [userActivities, setUserActivities] = useState([]);
//   const [userType] = useState('Buyer');

//   // ── Image carousel states ────────────────────────────────────────────────
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [images, setImages] = useState([]);
//   const [loadingImages, setLoadingImages] = useState(true);

//   // ── Property type / land check ────────────────────────────────────────────
//   const propertyType = property.propertyType || property.property_type || 'Land';
//   const isLand = String(propertyType).toLowerCase().includes('land');

//   // ── Field mapping ─────────────────────────────────────────────────────────
//   const postedBy = property.postedBy || property.posted_by || 'Agent';

//   // ── Price fallback chain ──────────────────────────────────────────────────
//   const priceValue =
//     property.price ??
//     property.effectivePrice ??
//     property.effective_price ??
//     property.minBudget ??
//     property.min_budget ??
//     property.budget ??
//     property.total_price ??
//     0;

//   // ── User plan ─────────────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchUserPlan = async () => {
//       if (!userId) { setUserPlan(null); return; }
//       try {
//         const r = await axios.get(`${BASE_URL}/Get-user-plan/${userId}/`);
//         const plans = r.data;
//         const active = Array.isArray(plans)
//           ? plans.find(p => p.user_type === userType)
//           : plans.user_type === userType ? plans : null;
//         setUserPlan(active);
//       } catch { setUserPlan(null); }
//     };
//     fetchUserPlan();
//   }, [userId, userType]);

//   // ── Activities ────────────────────────────────────────────────────────────
//   useEffect(() => {
//     const load = async () => {
//       if (!userId) return;
//       try {
//         const r = await fetch(`${BASE_URL}/activities/`);
//         const all = await r.json();
//         setUserActivities(all.filter(a => String(a.user_id) === String(userId)));
//       } catch { setUserActivities([]); }
//     };
//     load();
//   }, [userId]);

//   // ── Fetch images ──────────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchImages = async () => {
//       if (!property || !property.id) {
//         setImages(['/default-property-image.jpg']);
//         setLoadingImages(false);
//         return;
//       }

//       setLoadingImages(true);
//       try {
//         const response = await getPropertyImages(property.id);

//         // Handle different response shapes
//         let imgs = [];
//         if (response?.success && Array.isArray(response.images) && response.images.length > 0) {
//           imgs = response.images;
//         } else if (Array.isArray(response) && response.length > 0) {
//           imgs = response;
//         } else if (response?.images && Array.isArray(response.images)) {
//           imgs = response.images;
//         }

//         if (imgs.length > 0) {
//           const urls = imgs.map(img => {
//             // img might be a string URL or an object {image: '...'}
//             const raw = typeof img === 'string' ? img : (img.image || img.url || img.path || '');
//             if (!raw) return null;
//             return raw.startsWith('http') ? raw : `${BASE_URL}/${raw.replace(/^\/+/, '')}`;
//           }).filter(Boolean);

//           setImages(urls.length > 0 ? urls : ['/default-property-image.jpg']);
//         } else {
//           setImages(['/default-property-image.jpg']);
//         }
//       } catch (error) {
//         console.error(`Error fetching images for property ${property.id}:`, error);
//         setImages(['/default-property-image.jpg']);
//       } finally {
//         setLoadingImages(false);
//       }
//     };
//     fetchImages();
//   }, [property?.id]);

//   const displayImages = images.length > 0 ? images : ['/default-property-image.jpg'];

//   // ── Helpers ───────────────────────────────────────────────────────────────
//   const checkPropertyLimit = (pid) => {
//     if (userPlan?.no_of_properties_unlimited) return true;
//     const already = userActivities.some(a => a.property_id === pid && a.activity_as === userType);
//     if (already) return true;
//     const uniq = new Set(userActivities.filter(a => a.activity_as === userType).map(a => a.property_id));
//     if (uniq.size >= (userPlan?.no_of_properties || 10)) return false;
//     return true;
//   };

//   const logActivity = async (type) => {
//     try {
//       const exists = userActivities.find(a => a.property_id === property.id && a.activity_as === userType);
//       if (exists) return true;
//       let owner = property.owner_id ?? property.user_id ?? null;
//       if (!owner) {
//         try {
//           const r = await fetch(`${BASE_URL}/property/${property.id}/`);
//           if (r.ok) {
//             const d = await r.json();
//             owner = d.user_id ?? d.owner ?? d.posted_by ?? null;
//           }
//         } catch {}
//       }
//       const res = await fetch(`${BASE_URL}/activities/`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           user_id: userId, property_id: property.id,
//           activity_type: type, property_by: owner, activity_as: userType,
//         }),
//       });
//       if (!res.ok) throw new Error('fail');
//       const newA = await res.json();
//       setUserActivities(prev => [...prev, newA]);
//       return true;
//     } catch { return false; }
//   };

//   const requireLogin = (e, cb) => {
//     e.stopPropagation();
//     if (isGuest) { setShowGuestModal(true); return; }
//     cb();
//   };

//   // ── Location ──────────────────────────────────────────────────────────────
//   const handleLocationClick = (e) => {
//     requireLogin(e, () => {
//       const hasCoords = property.lat && property.lng;
//       const dest = hasCoords
//         ? `${property.lat},${property.lng}`
//         : encodeURIComponent(property.location || '');
//       if (!dest) { showAlert?.('failure', 'Location not available'); return; }

//       const ua = navigator.userAgent || navigator.vendor || window.opera;
//       const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;

//       const buildURL = (lat, lng) => {
//         if (isIOS) {
//           return lat
//             ? `https://maps.apple.com/?saddr=${lat},${lng}&daddr=${dest}&dirflg=d`
//             : `https://maps.apple.com/?q=${dest}`;
//         }
//         return lat
//           ? `https://www.google.com/maps/dir/?api=1&origin=${lat},${lng}&destination=${dest}&travelmode=driving`
//           : `https://www.google.com/maps/search/?api=1&query=${dest}`;
//       };
//       const open = (url) => { setLoading(false); window.open(url, '_blank', 'noopener,noreferrer'); };

//       if (navigator.geolocation && hasCoords) {
//         setLoading(true);
//         navigator.geolocation.getCurrentPosition(
//           (p) => open(buildURL(p.coords.latitude, p.coords.longitude)),
//           () => open(buildURL()),
//           { timeout: 8000, enableHighAccuracy: false }
//         );
//       } else {
//         open(buildURL());
//       }
//     });
//   };

//   // ── Call click ────────────────────────────────────────────────────────────
//   const handleCallClick = (e) => {
//     e.stopPropagation();

//     const phoneNumber = property.mobileNo || property.mobile_no;

//     if (phoneNumber) {
//       const proceedAction = () => {
//         navigator.clipboard.writeText(phoneNumber)
//           .then(() => {
//             showAlert ? showAlert('success', `Phone number copied: ${phoneNumber}`)
//                       : alert(`Phone number copied: ${phoneNumber}`);
//           })
//           .catch((error) => {
//             console.error('Failed to copy:', error);
//             showAlert?.('failure', 'Failed to copy phone number');
//           });
//       };

//       if (isGuest) setShowGuestModal(true);
//       else proceedAction();
//     } else {
//       const fetchAndCopyNumber = async () => {
//         try {
//           const ownerId = property.user_id || property.userId;
//           if (!ownerId) throw new Error('No user ID available');
//           const response = await axios.get(`${BASE_URL}/users/${ownerId}/`);
//           const user = response.data;

//           if (user && user.mobile_no) {
//             await navigator.clipboard.writeText(user.mobile_no);
//             showAlert?.('success', `Phone number copied: ${user.mobile_no}`);
//           } else {
//             throw new Error('No phone number found');
//           }
//         } catch (error) {
//           console.error('Error fetching phone number:', error);
//           showAlert?.('failure', 'No contact information available');
//         }
//       };

//       if (isGuest) setShowGuestModal(true);
//       else fetchAndCopyNumber();
//     }
//   };

//   // ── Card click ────────────────────────────────────────────────────────────
//   const handleCardClick = async (e) => {
//     e.stopPropagation();

//     if (isGuest) {
//       setShowGuestModal(true);
//       return;
//     }

//     const already = userActivities.some(
//       a => a.property_id === property.id && a.activity_as === userType
//     );

//     if (!already) {
//       if (!checkPropertyLimit(property.id)) return;
//       try { await logActivity('Description'); } catch (err) { console.error(err); }
//     }

//     localStorage.setItem('lastViewedPropertyId', property.id);
//     navigate(`/jv-jv-property-detail/${property.id}`);
//   };

//   const handleNextImage = (e) => {
//     e.stopPropagation();
//     setCurrentImageIndex((prev) => (prev + 1) % displayImages.length);
//   };

//   const handlePrevImage = (e) => {
//     e.stopPropagation();
//     setCurrentImageIndex((prev) => (prev - 1 + displayImages.length) % displayImages.length);
//   };

//   const pricePerUnit = getPricePerUnit(property);
//   const totalArea = getAreaNumber(property);

//   const locationParts = (property.location || '').split(',').map(s => s.trim()).filter(Boolean);
//   const localityLine = property.locality || property.area || locationParts[0] || 'Location';
//   const cityLine = property.city || property.state || locationParts.slice(1).join(', ') || '';

//   const minAcres = property.minAcres ?? property.min_acres ?? '-';
//   const maxAcres = property.maxAcres ?? property.max_acres ?? '-';
//   const facing   = property.facing || '-';

//   return (
//     <>
//       <Card
//         onClick={handleCardClick}
//         sx={{
//           display: 'flex',
//           flexDirection: 'row',
//           width: '100%',
//           height: 135,
//           maxWidth: 290,
//           cursor: 'pointer',
//           borderRadius: 2,
//           overflow: 'hidden',
//           transform: selected ? 'translateY(-2px)' : 'none',
//           transition: 'transform 200ms, border-color 200ms',
//           boxShadow: selected ? '0 4px 12px rgba(0,0,0,0.5)' : '0 2px 6px rgba(0,0,0,0.3)',
//           bgcolor: '#fff',
//           flexShrink: 0,
//         }}
//       >
//         {/* ── LEFT: Image 38% ─────────────────────────────────────────────── */}
//         <Box sx={{ position: 'relative', width: '38%', height: '100%' }}>
//           {loadingImages ? (
//             <Box sx={{
//               width: '100%', height: '100%', display: 'flex',
//               alignItems: 'center', justifyContent: 'center',
//               bgcolor: '#f5f5f5',
//             }}>
//               <CircularProgress size={24} />
//             </Box>
//           ) : (
//             <CardMedia
//               component="img"
//               image={displayImages[currentImageIndex]}
//               alt="Property"
//               onError={(e) => { e.target.src = '/default-property-image.jpg'; }}
//               sx={{
//                 width: '100%', height: '100%', objectFit: 'cover',
//                 borderTopLeftRadius: 8, borderBottomLeftRadius: 8,
//               }}
//             />
//           )}

//           {displayImages.length > 1 && !loadingImages && (
//             <>
//               <IconButton
//                 sx={{
//                   position: 'absolute', top: '50%', left: 4,
//                   transform: 'translateY(-50%)',
//                   backgroundColor: 'rgba(255,255,255,0.5)',
//                   '&:hover': { backgroundColor: 'rgba(255,255,255,0.8)' },
//                   p: 0.3, width: 22, height: 22,
//                 }}
//                 onClick={handlePrevImage}
//               >
//                 <ChevronLeft fontSize="small" />
//               </IconButton>
//               <IconButton
//                 sx={{
//                   position: 'absolute', top: '50%', right: 4,
//                   transform: 'translateY(-50%)',
//                   backgroundColor: 'rgba(255,255,255,0.5)',
//                   '&:hover': { backgroundColor: 'rgba(255,255,255,0.8)' },
//                   p: 0.3, width: 22, height: 22,
//                 }}
//                 onClick={handleNextImage}
//               >
//                 <ChevronRight fontSize="small" />
//               </IconButton>
//             </>
//           )}

//           {displayImages.length > 1 && !loadingImages && (
//             <Box sx={{
//               position: 'absolute', bottom: 6, left: '50%',
//               transform: 'translateX(-50%)', display: 'flex', gap: '4px',
//             }}>
//               {displayImages.map((_, index) => (
//                 <Box
//                   key={index}
//                   onClick={(e) => { e.stopPropagation(); setCurrentImageIndex(index); }}
//                   sx={{
//                     width: 6, height: 6, borderRadius: '50%',
//                     backgroundColor: currentImageIndex === index ? '#1976d2' : '#ccc',
//                     cursor: 'pointer',
//                   }}
//                 />
//               ))}
//             </Box>
//           )}
//         </Box>

//         {/* ── RIGHT: Content 62% ──────────────────────────────────────────── */}
//         <CardContent
//           sx={{
//             width: '62%', p: 1,
//             display: 'flex', flexDirection: 'column',
//             justifyContent: 'space-between',
//             height: 135, boxSizing: 'border-box',
//             '&:last-child': { pb: 1 },
//           }}
//         >
//           {/* Row 1: Title */}
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.2 }}>
//             <Typography
//               fontWeight="bold"
//               noWrap
//               sx={{
//                 fontSize: '0.75rem', lineHeight: 1.2,
//                 overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%',
//               }}
//             >
//               {propertyType }
//             </Typography>
//           </Box>

//           {/* Row 2: Price / Per sft | Total Price */}
//           <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.1, mb: 0.2 }}>
//            {/* Row 2: Min - Max acres | Total Price */}
// <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.1, mb: 0.2 }}>
//   <Box sx={{ flex: 1, minWidth: 0 }}>
//     <Typography sx={{ fontSize: '0.5rem', color: '#888', lineHeight: 1.1 }}>
//       Min - Max acres
//     </Typography>
//     <Typography sx={{ fontSize: '0.75rem', color: '#000', lineHeight: 1.2, fontWeight: 'bold' }}>
//       {property.min_acres ?? property.minAcres ?? '-'} - {property.max_acres ?? property.maxAcres ?? '-'}
//       <Typography component="span" sx={{ fontSize: '0.55rem', color: '#000', fontWeight: 400, ml: 0.4 }}>
//         acres
//       </Typography>
//     </Typography>
//   </Box>
// </Box>

//             <Box sx={{ width: '1px', height: 26, bgcolor: '#e0e0e0', mx: 0.6 }} />

//             <Box sx={{ flex: 1, minWidth: 0, textAlign: 'right' }}>
//               <Typography sx={{ fontSize: '0.5rem', color: '#888', lineHeight: 1.1 }}>
//                 Budget per Acre
//               </Typography>
//               <Typography fontWeight="bold" sx={{ fontSize: '0.7rem', lineHeight: 1.2 }}>
//                 ₹{formatPrice(priceValue)}
//               </Typography>
//             </Box>
//           </Box>

//       <Box
//   sx={{
//     display: 'flex',
//     alignItems: 'flex-start',                // ✅ pin at top when text wraps
//     gap: 0.5,
//     mt: 0.1, mb: 0.1, cursor: 'pointer',
//     borderRadius: 1, px: 0.3,
//     transition: 'background-color 0.15s',
//     '&:hover': { backgroundColor: 'rgba(201,138,44,0.10)' },
//   }}
// >
//   <LocationOn
//     sx={{
//       fontSize: '0.9rem',
//       color: '#c98a2c',
//       flexShrink: 0,
//       mt: 0.15,                              // ✅ align pin with first text line
//     }}
//   />

//   <Typography
//     sx={{
//       minWidth: 0,
//       flex: 1,
//       fontSize: '0.6rem',
//       color: '#333',
//       fontWeight: 500,
//       lineHeight: 1.2,
//       overflow: 'hidden',
//       display: '-webkit-box',                // ✅ 2-line clamp
//       WebkitLineClamp: 2,
//       WebkitBoxOrient: 'vertical',
//       textOverflow: 'ellipsis',
//       whiteSpace: 'normal',                  // ✅ allow wrapping
//       textDecoration: 'underline',
//       textDecorationColor: 'rgba(201,138,44,0.4)',
//     }}
//   >
//     {property.location || localityLine || 'Location not available'}
//   </Typography>
// </Box>

//           {/* Row 4: Info Grid */}
//           <Box
//             sx={{
//               display: 'flex', justifyContent: 'space-between', alignItems: 'center',
//               mt: 0.2, mb: 0.2, border: '1px solid #e0e0e0',
//               borderRadius: '8px', overflow: 'hidden', minHeight: 26,
//             }}
//           >
//             <Box sx={{ flex: 1.2, minWidth: 0, textAlign: 'center', p: 0.4, borderRight: '1px solid #e0e0e0' }}>
//               <Typography fontWeight="bold" noWrap sx={{ fontSize: '0.55rem', lineHeight: 1.1 }}>
//                 {postedBy}
//               </Typography>
//             </Box>

//             {/* <Box sx={{ flex: 1.4, minWidth: 0, textAlign: 'center', p: 0.4, borderRight: '1px solid #e0e0e0' }}>
//               <Typography
//                 fontWeight="bold" noWrap
//                 sx={{ fontSize: '0.55rem', lineHeight: 1.1, maxWidth: '60px' }}
//               >
//                 {isLand ? `${minAcres}/${maxAcres}` : (totalArea > 0 ? totalArea : 'N/A')}
//               </Typography>
//               <Typography noWrap sx={{ fontSize: '0.5rem', lineHeight: 1.1, color: '#666' }}>
//                 {isLand ? 'Acres' : (property.units || '')}
//               </Typography>
//             </Box> */}

//             <Box sx={{ flex: 1, minWidth: 0, textAlign: 'center', p: 0.3 }}>
//               <Typography fontWeight="bold" noWrap sx={{ fontSize: '0.55rem', lineHeight: 1.1 }}>
//                 {facing}
//               </Typography>
//               <Typography noWrap sx={{ fontSize: '0.5rem', lineHeight: 1.1, color: '#666' }}>
//                 Facing
//               </Typography>
//             </Box>
//           </Box>

//           {/* Row 5: View Details */}
//           <Button
//             variant="contained"
//             size="small"
//             fullWidth
//             onClick={handleCardClick}
//             sx={{
//               mt: 0.2, py: 0.18,
//               fontSize: '0.7rem', fontWeight: 600,
//               bgcolor: '#c98a2c', color: '#000',
//               borderRadius: '2px',
//               '&:hover': { bgcolor: '#f5f5f5' },
//               textTransform: 'none', minHeight: 22,
//               display: 'flex', justifyContent: 'space-between',
//               alignItems: 'center', px: 1.5,
//             }}
//           >
//             View Details
//             <ArrowForward sx={{ fontSize: '0.9rem' }} />
//           </Button>
//         </CardContent>
//       </Card>

//       <GuestLoginModal open={showGuestModal} onClose={() => setShowGuestModal(false)} />
//     </>
//   );
// }

// export default memo(JvJdPropertyCardImpl, (prevProps, nextProps) => {
//   return (
//     prevProps.property?.id === nextProps.property?.id &&
//     prevProps.selected === nextProps.selected
//   );
// });

import { memo, useState, useEffect, useContext, useRef } from 'react';
import {
  Card, CardMedia, CardContent, Box, Typography,
  IconButton, CircularProgress, Button, Tooltip,
} from '@mui/material';
import {
  LocationOn, ArrowForward, Call, ChevronLeft, ChevronRight,
} from '@mui/icons-material';
import { AuthContext } from './../../AuthContext/AuthContext';
import { BASE_URL } from './../../Api/ApiUrls';
import { getPropertyImages } from './api2.js';
import GuestLoginModal from '../../GuestLoginModal';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

// ✅ Import the fallback image as an asset
import buildingImage from './../../../Images/house.jpeg';

// ─── Full Indian number format ────────────────────────────────────────────────
const formatPrice = (price) => {
  const num = Number(price);
  if (!num || isNaN(num) || num <= 0) return '0';
  return num.toLocaleString('en-IN');
};

const formatPropertyId = (id) =>
  `PR${String(id || '').padStart(4, '0')}`;

const getAreaNumber = (property) => {
  if (!property) return 0;
  if (property.siteArea)     return parseFloat(property.siteArea)     || 0;
  if (property.buildupArea)  return parseFloat(property.buildupArea)  || 0;
  if (property.site_area)    return parseFloat(property.site_area)    || 0;
  if (property.buildup_area) return parseFloat(property.buildup_area) || 0;
  if (property.max_acres)    return parseFloat(property.max_acres)    || 0;
  if (property.maxAcres)     return parseFloat(property.maxAcres)     || 0;
  if (property.length && property.width) {
    return parseFloat(property.length) * parseFloat(property.width) || 0;
  }
  return 0;
};

const getPricePerUnit = (property) => {
  const rawPrice =
    property?.price ??
    property?.effectivePrice ??
    property?.effective_price ??
    property?.minBudget ??
    property?.min_budget ??
    property?.budget ??
    property?.total_price;

  const price = parseFloat(String(rawPrice ?? '').replace(/[^0-9.]/g, ''));
  if (!price || price <= 0) return null;

  const area = getAreaNumber(property);
  if (!area || area <= 0) return null;

  const u = String(property.units || '').toLowerCase();
  let unit = 'sft';
  if (['acre', 'acres'].includes(u))   unit = 'acre';
  if (['gunta', 'guntas'].includes(u)) unit = 'gunta';

  return { value: Math.round(price / area), unit };
};

// ✅ Normalize any image URL (string or object) to an absolute URL
const normalizeImageUrl = (raw) => {
  if (!raw) return null;
  const s = String(raw).trim();
  if (!s) return null;
  if (s.startsWith('http://') || s.startsWith('https://') || s.startsWith('data:')) return s;
  const base = String(BASE_URL || '').replace(/\/+$/, '');
  return `${base}/${s.replace(/^\/+/, '')}`;
};

function JvJdPropertyCardImpl({ property, selected, onClick, showAlert, activityType }) {
  const { userId, isGuest } = useContext(AuthContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [showGuestModal, setShowGuestModal] = useState(false);
  const [userPlan, setUserPlan] = useState(null);
  const [userActivities, setUserActivities] = useState([]);
  const [userType] = useState('Buyer');

  // ── Image carousel states ────────────────────────────────────────────────
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [images, setImages] = useState([]);
  const [loadingImages, setLoadingImages] = useState(true);

  // ✅ Image load state (tracks the <img> element, not the fetch)
  const [imageLoaded, setImageLoaded] = useState(false);

  // ✅ Guard against state updates after unmount / stale fetches
  const isMountedRef = useRef(true);
  useEffect(() => () => { isMountedRef.current = false; }, []);

  // ── Property type / land check ────────────────────────────────────────────
  const propertyType = property.propertyType || property.property_type || 'Land';
  const isLand = String(propertyType).toLowerCase().includes('land');

  // ── Field mapping ─────────────────────────────────────────────────────────
  const postedBy = property.postedBy || property.posted_by || 'Agent';

  // ── Price fallback chain ──────────────────────────────────────────────────
  const priceValue =
    property.price ??
    property.effectivePrice ??
    property.effective_price ??
    property.minBudget ??
    property.min_budget ??
    property.budget ??
    property.total_price ??
    0;

  // ── User plan ─────────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchUserPlan = async () => {
      if (!userId) { setUserPlan(null); return; }
      try {
        const r = await axios.get(`${BASE_URL}/Get-user-plan/${userId}/`);
        const plans = r.data;
        const active = Array.isArray(plans)
          ? plans.find(p => p.user_type === userType)
          : plans.user_type === userType ? plans : null;
        if (isMountedRef.current) setUserPlan(active);
      } catch { if (isMountedRef.current) setUserPlan(null); }
    };
    fetchUserPlan();
  }, [userId, userType]);

  // ── Activities ────────────────────────────────────────────────────────────
  useEffect(() => {
    const load = async () => {
      if (!userId) return;
      try {
        const r = await fetch(`${BASE_URL}/activities/`);
        const all = await r.json();
        if (isMountedRef.current) {
          setUserActivities(Array.isArray(all)
            ? all.filter(a => String(a.user_id) === String(userId))
            : []);
        }
      } catch { if (isMountedRef.current) setUserActivities([]); }
    };
    load();
  }, [userId]);

  // ── Fetch images (single fetch per property.id) ───────────────────────────
  useEffect(() => {
    let cancelled = false;

    const fetchImages = async () => {
      if (!property || !property.id) {
        if (!cancelled) {
          setImages([buildingImage]);
          setLoadingImages(false);
        }
        return;
      }

      setLoadingImages(true);

      try {
        const response = await getPropertyImages(property.id);

        // Handle different response shapes
        let imgs = [];
        if (response?.success && Array.isArray(response.images) && response.images.length > 0) {
          imgs = response.images;
        } else if (Array.isArray(response) && response.length > 0) {
          imgs = response;
        } else if (response?.images && Array.isArray(response.images)) {
          imgs = response.images;
        } else if (Array.isArray(response?.data) && response.data.length > 0) {
          imgs = response.data;
        }

        const urls = imgs
          .map(img => {
            const raw = typeof img === 'string'
              ? img
              : (img?.image || img?.url || img?.path || '');
            return normalizeImageUrl(raw);
          })
          .filter(Boolean);

        if (cancelled || !isMountedRef.current) return;
        setImages(urls.length > 0 ? urls : [buildingImage]);
      } catch (error) {
        console.error(`Error fetching images for property ${property.id}:`, error);
        if (!cancelled && isMountedRef.current) setImages([buildingImage]);
      } finally {
        if (!cancelled && isMountedRef.current) setLoadingImages(false);
      }
    };

    fetchImages();
    return () => { cancelled = true; };
  }, [property?.id]);

  const displayImages = images.length > 0 ? images : [buildingImage];
  const activeImage = displayImages[currentImageIndex] || buildingImage;

  // ✅ Reset imageLoaded whenever the active image changes
  useEffect(() => {
    setImageLoaded(false);
  }, [activeImage]);

  // ── Helpers ───────────────────────────────────────────────────────────────
  const checkPropertyLimit = (pid) => {
    if (userPlan?.no_of_properties_unlimited) return true;
    const already = userActivities.some(a => a.property_id === pid && a.activity_as === userType);
    if (already) return true;
    const uniq = new Set(userActivities.filter(a => a.activity_as === userType).map(a => a.property_id));
    if (uniq.size >= (userPlan?.no_of_properties || 10)) return false;
    return true;
  };

  const logActivity = async (type) => {
    try {
      const exists = userActivities.find(a => a.property_id === property.id && a.activity_as === userType);
      if (exists) return true;
      let owner = property.owner_id ?? property.user_id ?? null;
      if (!owner) {
        try {
          const r = await fetch(`${BASE_URL}/property/${property.id}/`);
          if (r.ok) {
            const d = await r.json();
            owner = d.user_id ?? d.owner ?? d.posted_by ?? null;
          }
        } catch {}
      }
      const res = await fetch(`${BASE_URL}/activities/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user_id: userId, property_id: property.id,
          activity_type: type, property_by: owner, activity_as: userType,
        }),
      });
      if (!res.ok) throw new Error('fail');
      const newA = await res.json();
      setUserActivities(prev => [...prev, newA]);
      return true;
    } catch { return false; }
  };

  const requireLogin = (e, cb) => {
    e.stopPropagation();
    if (isGuest) { setShowGuestModal(true); return; }
    cb();
  };

  // ── Location ──────────────────────────────────────────────────────────────
  const handleLocationClick = (e) => {
    requireLogin(e, () => {
      const hasCoords = property.lat && property.lng;
      const dest = hasCoords
        ? `${property.lat},${property.lng}`
        : encodeURIComponent(property.location || '');
      if (!dest) { showAlert?.('failure', 'Location not available'); return; }

      const ua = navigator.userAgent || navigator.vendor || window.opera;
      const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;

      const buildURL = (lat, lng) => {
        if (isIOS) {
          return lat
            ? `https://maps.apple.com/?saddr=${lat},${lng}&daddr=${dest}&dirflg=d`
            : `https://maps.apple.com/?q=${dest}`;
        }
        return lat
          ? `https://www.google.com/maps/dir/?api=1&origin=${lat},${lng}&destination=${dest}&travelmode=driving`
          : `https://www.google.com/maps/search/?api=1&query=${dest}`;
      };
      const open = (url) => { setLoading(false); window.open(url, '_blank', 'noopener,noreferrer'); };

      if (navigator.geolocation && hasCoords) {
        setLoading(true);
        navigator.geolocation.getCurrentPosition(
          (p) => open(buildURL(p.coords.latitude, p.coords.longitude)),
          () => open(buildURL()),
          { timeout: 8000, enableHighAccuracy: false }
        );
      } else {
        open(buildURL());
      }
    });
  };

  // ── Call click ────────────────────────────────────────────────────────────
  const handleCallClick = (e) => {
    e.stopPropagation();
    const phoneNumber = property.mobileNo || property.mobile_no;

    if (phoneNumber) {
      const proceedAction = () => {
        navigator.clipboard.writeText(phoneNumber)
          .then(() => {
            showAlert ? showAlert('success', `Phone number copied: ${phoneNumber}`)
                      : alert(`Phone number copied: ${phoneNumber}`);
          })
          .catch((error) => {
            console.error('Failed to copy:', error);
            showAlert?.('failure', 'Failed to copy phone number');
          });
      };
      if (isGuest) setShowGuestModal(true);
      else proceedAction();
    } else {
      const fetchAndCopyNumber = async () => {
        try {
          const ownerId = property.user_id || property.userId;
          if (!ownerId) throw new Error('No user ID available');
          const response = await axios.get(`${BASE_URL}/users/${ownerId}/`);
          const user = response.data;
          if (user && user.mobile_no) {
            await navigator.clipboard.writeText(user.mobile_no);
            showAlert?.('success', `Phone number copied: ${user.mobile_no}`);
          } else {
            throw new Error('No phone number found');
          }
        } catch (error) {
          console.error('Error fetching phone number:', error);
          showAlert?.('failure', 'No contact information available');
        }
      };
      if (isGuest) setShowGuestModal(true);
      else fetchAndCopyNumber();
    }
  };

  // ── Card click ────────────────────────────────────────────────────────────
  const handleCardClick = async (e) => {
    e.stopPropagation();
    if (isGuest) { setShowGuestModal(true); return; }

    const already = userActivities.some(
      a => a.property_id === property.id && a.activity_as === userType
    );
    if (!already) {
      if (!checkPropertyLimit(property.id)) return;
      try { await logActivity('Description'); } catch (err) { console.error(err); }
    }
    localStorage.setItem('lastViewedPropertyId', property.id);
    navigate(`/jv-jv-property-detail/${property.id}`);
  };

  const handleNextImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => (prev + 1) % displayImages.length);
  };

  const handlePrevImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => (prev - 1 + displayImages.length) % displayImages.length);
  };

  const pricePerUnit = getPricePerUnit(property);
  const totalArea = getAreaNumber(property);

  const locationParts = (property.location || '').split(',').map(s => s.trim()).filter(Boolean);
  const localityLine = property.locality || property.area || locationParts[0] || 'Location';
  const cityLine = property.city || property.state || locationParts.slice(1).join(', ') || '';

  const facing = property.facing || '-';

  return (
    <>
      <Card
        onClick={handleCardClick}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          height: 135,
          maxWidth: 290,
          cursor: 'pointer',
          borderRadius: 2,
          overflow: 'hidden',
          transform: selected ? 'translateY(-2px)' : 'none',
          transition: 'transform 200ms, border-color 200ms',
          boxShadow: selected ? '0 4px 12px rgba(0,0,0,0.5)' : '0 2px 6px rgba(0,0,0,0.3)',
          bgcolor: '#fff',
          flexShrink: 0,
        }}
      >
        {/* ── LEFT: Image 38% ─────────────────────────────────────────────── */}
        <Box sx={{ position: 'relative', width: '38%', height: '100%', overflow: 'hidden' }}>
          {/* ✅ Always render the img — no unmounting, no blinking */}
          <CardMedia
            component="img"
            image={activeImage}
            alt="Property"
            onLoad={() => setImageLoaded(true)}
            onError={(e) => {
              if (e.target.src !== buildingImage) {
                e.target.src = buildingImage;
              }
              setImageLoaded(true); // stop spinner even if it falls back
            }}
            sx={{
              width: '100%', height: '100%', objectFit: 'cover',
              borderTopLeftRadius: 8, borderBottomLeftRadius: 8,
              display: 'block',
              // ✅ Hide img until it's actually loaded (first paint only)
              opacity: imageLoaded ? 1 : 0,
              transition: 'opacity 180ms ease-in',
            }}
          />

          {/* ✅ Spinner overlay — ONLY while the image is decoding */}
          {!imageLoaded && (
            <Box sx={{
              position: 'absolute', inset: 0,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              bgcolor: '#f5f5f5',
              pointerEvents: 'none',
            }}>
              <CircularProgress size={20} />
            </Box>
          )}

          {displayImages.length > 1 && imageLoaded && (
            <>
              <IconButton
                sx={{
                  position: 'absolute', top: '50%', left: 4,
                  transform: 'translateY(-50%)',
                  backgroundColor: 'rgba(255,255,255,0.5)',
                  '&:hover': { backgroundColor: 'rgba(255,255,255,0.8)' },
                  p: 0.3, width: 22, height: 22,
                }}
                onClick={handlePrevImage}
              >
                <ChevronLeft fontSize="small" />
              </IconButton>
              <IconButton
                sx={{
                  position: 'absolute', top: '50%', right: 4,
                  transform: 'translateY(-50%)',
                  backgroundColor: 'rgba(255,255,255,0.5)',
                  '&:hover': { backgroundColor: 'rgba(255,255,255,0.8)' },
                  p: 0.3, width: 22, height: 22,
                }}
                onClick={handleNextImage}
              >
                <ChevronRight fontSize="small" />
              </IconButton>
            </>
          )}

          {displayImages.length > 1 && imageLoaded && (
            <Box sx={{
              position: 'absolute', bottom: 6, left: '50%',
              transform: 'translateX(-50%)', display: 'flex', gap: '4px',
            }}>
              {displayImages.slice(0, 5).map((_, index) => (
                <Box
                  key={index}
                  onClick={(e) => { e.stopPropagation(); setCurrentImageIndex(index); }}
                  sx={{
                    width: 6, height: 6, borderRadius: '50%',
                    backgroundColor: currentImageIndex === index ? '#1976d2' : '#ccc',
                    cursor: 'pointer',
                  }}
                />
              ))}
            </Box>
          )}
        </Box>

        {/* ── RIGHT: Content 62% ──────────────────────────────────────────── */}
        <CardContent
          sx={{
            width: '62%', p: 1,
            display: 'flex', flexDirection: 'column',
            justifyContent: 'space-between',
            height: 135, boxSizing: 'border-box',
            '&:last-child': { pb: 1 },
          }}
        >
          {/* Row 1: Title */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.2 }}>
            <Typography
              fontWeight="bold"
              noWrap
              sx={{
                fontSize: '0.75rem', lineHeight: 1.2,
                overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%',
              }}
            >
              {propertyType}
            </Typography>
          </Box>

          {/* Row 2: Budget per Acre (centered) */}
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 0.1, mb: 0.2 }}>
            <Box sx={{ textAlign: 'center', minWidth: 0 }}>
              <Typography sx={{ fontSize: '0.5rem', color: '#888', lineHeight: 1.1 }}>
                Budget per Acre
              </Typography>
              <Typography fontWeight="bold" sx={{ fontSize: '0.75rem', lineHeight: 1.2, color: '#1F1F1F' }}>
                ₹{formatPrice(priceValue)}
              </Typography>
            </Box>
          </Box>

          {/* Row 3: Location */}
          <Box
            // onClick={handleLocationClick}
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 0.5,
              mt: 0.1, mb: 0.1, cursor: 'pointer',
              borderRadius: 1, px: 0.3,
              transition: 'background-color 0.15s',
              '&:hover': { backgroundColor: 'rgba(201,138,44,0.10)' },
            }}
          >
            <LocationOn
              sx={{
                fontSize: '0.9rem',
                color: '#8B4F16',
                flexShrink: 0,
                mt: 0.15,
              }}
            />
            <Typography
              sx={{
                minWidth: 0,
                flex: 1,
                fontSize: '0.6rem',
                color: '#333',
                fontWeight: 500,
                lineHeight: 1.2,
                overflow: 'hidden',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                textOverflow: 'ellipsis',
                whiteSpace: 'normal',
                textDecoration: 'underline',
                textDecorationColor: 'rgba(201,138,44,0.4)',
              }}
            >
              {property.location || localityLine || 'Location not available'}
            </Typography>
          </Box>

          {/* Row 4: Info Grid */}
          <Box
            sx={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              mt: 0.2, mb: 0.2, border: '1px solid #e0e0e0',
              borderRadius: '8px', overflow: 'hidden', minHeight: 26,
            }}
          >
            <Box sx={{ flex: 1.2, minWidth: 0, textAlign: 'center', p: 0.4, borderRight: '1px solid #e0e0e0' }}>
              <Typography fontWeight="bold" noWrap sx={{ fontSize: '0.55rem', lineHeight: 1.1, fontWeight: 900 }}>
                {postedBy}
              </Typography>
            </Box>

            <Box sx={{ flex: 1, minWidth: 0, textAlign: 'center', p: 0.3 }}>
              <Typography fontWeight="bold" noWrap sx={{ fontSize: '0.55rem', lineHeight: 1.1, fontWeight: 900 }}>
                {facing}
              </Typography>
              <Typography noWrap sx={{ fontSize: '0.5rem', lineHeight: 1.1, color: '#666' }}>
                Facing
              </Typography>
            </Box>
          </Box>

          {/* Row 5: View Details */}
          <Button
            variant="contained"
            size="small"
            fullWidth
            onClick={handleCardClick}
            sx={{
              mt: 0.2, py: 0.18,
              fontSize: '0.7rem', fontWeight: 600,
              bgcolor: '#8B4F16', color: '#fff',
              borderRadius: '2px',
              '&:hover': { bgcolor: '#f5f5f5' },
              textTransform: 'none', minHeight: 22,
              display: 'flex', justifyContent: 'space-between',
              alignItems: 'center', px: 1.5,
            }}
          >
            View Details
            <ArrowForward sx={{ fontSize: '0.9rem' }} />
          </Button>
        </CardContent>
      </Card>

      <GuestLoginModal open={showGuestModal} onClose={() => setShowGuestModal(false)} />
    </>
  );
}

export default memo(JvJdPropertyCardImpl, (prevProps, nextProps) => {
  return (
    prevProps.property?.id === nextProps.property?.id &&
    prevProps.selected === nextProps.selected
  );
});